import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../redux/reducers/index'
import {Body,Title} from '../../theme/theme'
import {useParams} from "react-router-dom";
import BreadCrumb from "../../components/BreadCrumb";
import {path} from "../../config/enviroment";
import {callCategoriesDetail, cleanCategoriesDetail, setRoute, setCategoryDetailName, handleResetQuote} from '../../redux/actions';
import CardCategoryDetail from "../../components/CardCategoryDetail";
import {getCategoryname} from "../../utils/getNameById";
import HeadPagination from "../../components/HeadPagination";
import FooterPagination from "../../components/FooterPagination";
import useView from "../../hooks/useView";
import {ContainerCategoryDetail} from './style'
import { language } from '../../utils/language';
import FreeShippingMinBanner from '../../components/FreeShippingMinBanner';


const CategoryDetail = (props:any) => {
    const homeState: HomeStateType = useSelector((state: RootState) => state.home)
    const categoryDetailState: any = useSelector((state: RootState) => state.categoryDetail)
    const categoryState: any = useSelector((state: RootState) => state.category)
    const { idCategory }: any = useParams()
    const [order, setOrder] = useState('outstanding')
    const [page, setPage] = useState(1)
    const [categoryName, setCategoryName] = useState('')
    const [typeList, setTypeList] = useState('colum')
    const dispatch = useDispatch()
    const {width} = useView()

    let isMobile = false;
    if(width <= 1000) {
        isMobile = true;
    }

    const handleList = (pageSelected: number) => {
        dispatch(cleanCategoriesDetail())
        setPage(pageSelected)
        getCategoriesDetail(order, pageSelected)
    }

    const handleOrder = (event:any) => {
        dispatch(cleanCategoriesDetail())
        setOrder(event.target.value)
        getCategoriesDetail(event.target.value)
    }

    const getCategoriesDetail = (ord = order, pg = page) => {
        let filter: {}
        if(parseInt(idCategory) === 0){
            filter = {
                url: path,
                filter: {
                    origin:"epayco",
                    outstanding: true
                },
                pagination:{
                    page:pg,
                    limit: isMobile ? 8 : 12
                }
            }
        }else{
             filter = {
                url: path,
                filter: {
                    origin:"epayco",
                    order: ord,
                    categorieId: parseInt(idCategory)
                },
                pagination:{
                    page:pg,
                    limit: isMobile ? 8 : 12
                }
            }
        }
        dispatch(callCategoriesDetail(path, filter, homeState.manage))
    }

    const handleTypeList = (type: string) => {
       setTypeList(type)
    }

    useEffect(() => {
        dispatch(cleanCategoriesDetail())
        getCategoriesDetail()
        dispatch(handleResetQuote())
    }, [])

    useEffect(() => {
        if(parseInt(idCategory) === 0){
            setCategoryName(language[homeState.default_language]["featured"])
            dispatch(setCategoryDetailName(language[homeState.default_language]["featured"]))
        }else{
            setCategoryName(getCategoryname(idCategory, categoryState.listCategory, homeState.default_language))
            const catName = getCategoryname(idCategory, categoryState.listCategory, homeState.default_language)
            dispatch(setRoute({
                route: "/",
                routeName: catName,
            }))
        }
    }, [categoryState])

    useEffect(() => {
        // si el id de la categoria es invalida retorna a 404
        if(categoryDetailState.listCategoryDetail.length === 0 && !categoryDetailState.loading){
            props.history.push(`/vende/${homeState.catalogueUrlName}/error`)
           
        }
    },[categoryDetailState])

    return (
        <>
            {!homeState.loading ? (
                <>
                    <Body>
                        {
                        <>
                            <BreadCrumb linkName1={'Categorías'} linkroute1={`vende/${homeState.catalogueName}/categories`} currentPage={categoryName}/>
                            <FreeShippingMinBanner inContent />
                            <ContainerCategoryDetail>
                                <>
                                {!isMobile &&
                                <Title color={homeState.color}>
                                    {categoryName}
                                </Title>
                                }
                                <HeadPagination
                                    homeState={homeState}
                                    list={categoryDetailState.listCategoryDetailPaginate}
                                    handleOrder={handleOrder}
                                    typeList={typeList}
                                    handleTypeList={handleTypeList}
                                    isMobile={isMobile}
                                    idCategory={parseInt(idCategory)}
                                />
                                <CardCategoryDetail
                                    showAsGrid={true}
                                    skeletonCardsRows={3}
                                    homeState={homeState}
                                    productList={categoryDetailState.listCategoryDetail}
                                    typeList={typeList}
                                    loading={categoryDetailState.loading}
                                    isMobile={isMobile}
                                />
                                </>
                            </ContainerCategoryDetail>
                            <FooterPagination
                                homeState={homeState}
                                list={categoryDetailState.listCategoryDetailPaginate}
                                handleList={handleList}
                                loading={categoryDetailState.loading}
                                isMobile={isMobile}
                            />
                        </>
                        }
                    </Body>
                </>
            ) : (
                <p>{language[homeState.default_language]["loading"]}...</p>
            )}
        </>
    )
}

export default CategoryDetail